import { render } from "./TestManager.vue?vue&type=template&id=762a66fe"
import script from "./TestManager.vue?vue&type=script&lang=js"
export * from "./TestManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__